import React from "react";
import Chats from "../containers/admin/ChatLayout";
import { Route, Routes } from "react-router";
import Settings from "../containers/admin/Settings";
import AdminTask from "../containers/admin/Task";
import EmployeeTask from "../containers/admin/Task/EmployeeTask";
import AddEmployee from "../containers/admin/AllEmployee/AddEmployee";

const wareHouseRoutes = () => {
  return (
    <div>
      <Routes>
        <Route path="/chats" element={<Chats />} />
        <Route path="/employee/add-employee" element={<AddEmployee />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/task" element={<AdminTask />} />
        <Route path="/task-admin" element={<EmployeeTask />} />
      </Routes>
    </div>
  );
};

export default wareHouseRoutes;
